import ProfileOfClaimant from "../components/ProfileOfClaimant";
import DetailsOfDispute from "../components/DetailsOfDispute";
import RequiredDocuments from "../components/RequiredDocuments";
import CalculationOfFees from "../components/CalculationOfFees";

export const steps = [
  {
    name: "Profile of Claimant",
    content: <ProfileOfClaimant />,
  },
  {
    name: "Details of Dispute",
    content: <DetailsOfDispute />,
  },
  {
    name: "Required Documents",
    content: <RequiredDocuments />,
  },
  {
    name: "Calculation of Fees",
    content: <CalculationOfFees />,
  },
]; 